import { useRef, useState, useEffect } from "react";

/**
 * Wrapper that measures its parent and passes explicit pixel dimensions to children.
 * Avoids Recharts ResponsiveContainer's "width(-1) height(-1)" warning on first render.
 */
export default function ChartFrame({ height = 240, children }) {
  const ref = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (!ref.current) return;
    const ro = new ResizeObserver((entries) => {
      const w = Math.floor(entries[0].contentRect.width);
      if (w > 0) setWidth(w);
    });
    ro.observe(ref.current);
    return () => ro.disconnect();
  }, []);

  return (
    <div ref={ref} style={{ width: "100%", height }}>
      {width > 0 && typeof children === "function" ? children({ width, height }) : null}
    </div>
  );
}
